if (!customElements.get('product-page-content')) {
  customElements.define(
    'product-page-content',
    class ProductPageContent extends HTMLElement {

      productVariantsData;
      partData;
      productPartPicker;
      productCanvas;
      productInfo;
      stickySections;
      sticky_mobile;

      constructor() {
        super();


        this.input = this.querySelector('.quantity__input');
        this.submitButton = this.querySelector('[type="submit"]');

        this.priceVariantIDUpdated = this.dataset.variantid;
        var partData = [];
        var parts = this.getElementsByClassName("product-part");
        for (let index = 0; index < parts.length; index++) {
          const element = parts[index];
          var partName = element.getAttribute("data-partname");
          let item = {
            partName: partName,
            partValues: []
          }
          partData.push(item)
          let tabContent = document.getElementById("tab-" + partName);
          var tabsContent = this.getElementsByClassName("tab-" + partName);
          let buttons = []
          for (let indexTab = 0; indexTab < tabsContent.length; indexTab++) {
            const element = tabsContent[indexTab];
            let childButtons = element.getElementsByTagName("product-part-button");
            buttons.push(...childButtons)
          }
          for (let indexButton = 0; indexButton < buttons.length; indexButton++) {
            const button = buttons[indexButton];
            var order = button.getAttribute("data-order");
            var btnBValue = button.getAttribute("data-partvalue")
            var img1 = button.getAttribute("data-view1")
            var img2 = button.getAttribute("data-view2")
            var img3 = button.getAttribute("data-view3")
            var partID = button.getAttribute("data-part-shopify-id")
            item.partValues.push({
              partValue: btnBValue,
              partID: partID,
              order: order,
              view1: img1,
              view2: img2,
              view3: img3
            })
          }
        }
        this.partData = partData;
        //console.log("partData", this.partData);

        this.productCanvas = this.getElementsByTagName("product-canvas").item(0);
        this.productCanvas = this.getElementsByTagName("product-canvas").item(0);
        this.productInfo = this.getElementsByTagName("product-info").item(0);


        this.productVariantsData = this.getElementsByTagName("product-variants-data").item(0);
        this.productPartPicker = this.getElementsByTagName("product-custom-part-picker");
        var _this = this;
      }


      isIntoView(selector) {
        // if ($(document).scrollTop() >= $(selector).offset().top && $(document).scrollTop() < $(selector).offset().top +  $(selector).height())
        // var docViewTop = $(window).scrollTop();
        // var docViewBottom = docViewTop + $(window).height();
        // var elemTop = $(selector).offset().top;
        // return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
        var buffer = - $(window).height() / 2;
        return ($(document).scrollTop() >= $(selector).offset().top + buffer && $(document).scrollTop() < $(selector).offset().top + $(selector).height() + buffer)
      }

      /**
       * 
       * @param {*} data // {"partShopifyID": string}[]
       */
      updatePrice(data) {
        this.currentVariant = this.getVariant(data);
        if (this.currentVariant)
          this.updateAddToCartForm(this.currentVariant.id)

        if (this.currentVariant && this.currentVariant.id != this.priceVariantIDUpdated) {
          this.priceVariantIDUpdated = this.currentVariant.id
          this.fetchPrice();
          this.udpatePriceV2(this.dataset.section, this.currentVariant);
          // console.log(data);

        }
      }

      updateAddToCartForm(variantID) {
        $("product-form .product-variant-id").val(variantID);
        $("product-form .product-url-selected").val(window.location.href);

      }
      initProductData() {
      }
      getVariant(data) {
        var variantSelected;
        var partIDs = [];
        var values = Object.values(data);

        for (let index = 0; index < values.length; index++) {
          const element = values[index];
          partIDs.push(element.partShopifyID);
        }
        var variantSelected = this.productVariantsData.getVariantSelected(partIDs);
        //console.log("getVariant", partIDs);

        return variantSelected;
      }
      initPart() {

        const variantSelected = this.productVariantsData.getInitPartValue();
        const urlParams = new URLSearchParams(window.location.search);
        if (variantSelected.length > 0) {
          var partIdsSelected = variantSelected
        }
        else {
          var partIdsSelected = urlParams.get("parts") || [];
        }

        // console.log("getInitPartSelected", this.productVariantsData.getInitPartValue());

        var keys = Array.from(urlParams.keys());


        for (let index = 0; index < this.partData.length; index++) {
          const element = this.partData[index];
          let valueSelected = element.partValues.find(el => {
            return partIdsSelected.includes(el.partValue)
          })?.partValue;



          let selectedVal = element.partValues[0];
          if (valueSelected) {
            var matchItem = element.partValues.find(el => el.partValue == valueSelected);
            if (matchItem) {
              selectedVal = matchItem;
            }
          }

          var firtPart = this.partData[0];
          //select first key
          const { partValue, order, view1, view2, view3, partID } = selectedVal;
          this.productCanvas.setPartValue(element.partName, partValue, view1, view2, view3, order, partID)

          //console.log("SetPartValue", element.partName, partValue);
          // var a = document.getElementsByTagName("s")
          // console.log("this.productPartPicker", this.productPartPicker);
          // a.length
          for (let index = 0; index < this.productPartPicker.length; index++) {
            const partEl = this.productPartPicker.item(index);
            partEl.setActivePart(element.partName, partValue)
            if (firtPart) partEl.openTab(firtPart.partName);

          }
        }


        if (this.partData.length == 0) {
          this.productCanvas.showFeaturedImage()
        }

      }
      getPartData() {
        return this.partData;
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {

        this.initProductData();
        this.initPart();

        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchPrice.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchPrice(force = false) {

        //update price
        if (force == false) {
          if (!this.currentVariant || !this.currentVariant.id) return;
        }
        // this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        if (this.currentVariant) {
          var url = `${this.currentVariant.data.productUrl}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`

        } else {
          var url = `${this.dataset.url}?section_id=${this.dataset.section}`
        }
        fetch(url)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updatePriceHTML(this.dataset.section, html);
            this.updateDiscountCode(html);

            // this.updateQuantityRules(this.dataset.section, html);
            // this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }
      updateDiscountCode(html) {
        var discount = html.querySelector('discount-code')?.dataset.code;
        window.product_discount_code = discount ? discount : '';
      }

      stringToHTML = (str) => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(str, 'text/html');
        return doc.body;
      };
      udpatePriceV2(sectionId, variantData) {
        // return;
        const { price, price_html, available, compare_at_price, compare_at_price_html } = variantData.data;
        //console.log("udpatePriceV2", window);

        // console.log("udpatePriceV2", price, price_html, available, compare_at_price, compare_at_price_html, variantData);
        var selector = `price-${sectionId}`;
        const priceContainer = document.getElementById(selector);
        priceContainer.classList.add("price-loading")
        return;
      }
      priceVariantIDUpdated;

      updatePriceHTML(sectionId, html) {
        var selector = `price-${sectionId}`;
        const priceFormUpdated = html.getElementById(selector);
        //console.log("updatePrice", this.currentVariant);
        if (priceFormUpdated.dataset.variantid != this.currentVariant.id) return;

        const currentPrice = document.getElementById(selector);
        currentPrice.innerHTML = priceFormUpdated.innerHTML;


        const priceContainer = document.getElementById(selector);
        // priceContainer.classList.add("show-price")
        // priceContainer.classList.remove("hide-price")
        priceContainer.classList.remove("price-loading")


        const priceHeaderEl = document.getElementById("price-header-main-product")
        if (priceHeaderEl) {
          const priceHeaderFormUpdated = html.getElementById("price-header-main-product");

          if (priceHeaderFormUpdated && priceHeaderFormUpdated.length>0)
            priceHeaderEl.innerHTML = priceHeaderFormUpdated.innerHTML
        }

        const buttonAddToCart = html.getElementById("ProductSubmitButton-" + sectionId);
        //console.log('>>>buttonAddToCart', buttonAddToCart)
        if (buttonAddToCart) {
          const _buttonAddToCart = document.getElementsByClassName("ProductSubmitButton-" + sectionId);
          for (let index = 0; index < _buttonAddToCart.length; index++) {
            const element = _buttonAddToCart[index];
            const hasClassIsLen = element.classList.contains("is-lens");
            if (hasClassIsLen) {
              buttonAddToCart.classList.add("is-lens")
            }
            element.outerHTML = buttonAddToCart.outerHTML;

          }
        }

      }
      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

    }
  );
}
